/*global CONFIG*/
import Papa from 'papaparse'


const papaconfig = {
  delimiter: ";",	// auto-detect
  newline: "\n",	// auto-detect
  header: true,
  skipEmptyLines: true,
  dynamicTyping: false,
  transform: (v) => v.trim(),
  transformHeader: (h) => h.trim()
}

class DataLoading {

  getFile(url, name) {
    return new Promise( (resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url + "?rand=" + Math.floor(Math.random() * 100000));
      xhr.send();

      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let content = xhr.responseText
            let extension = url.split('.').pop()
            let parsed
            if(extension === "csv") {
              parsed = Papa.parse(content, papaconfig).data.filter(line => line.id !== null);
            } else if(extension === "json" || extension === "config") {
              parsed = JSON.parse(content)
            } else if(extension === "data") {

              let d = JSON.parse(content)
              if(d.infos && d.infos.version === 2) {
                let coltypes = {}
                d.columns.forEach(c => coltypes[c.name] = c.type)
                parsed = d.data.map(obj => {
                  for(let k in obj) {
                    if(coltypes[k] === "numeric" && obj[k]) obj[k] = parseFloat(obj[k])
                  }
                  return obj
                })
              } else {
                parsed = []
                d.data.map(line => {
                  let lineObj = {}
                  d.columns.forEach(({title, type}, index) => {
                    let value = line[index]
                    value = value === "" ? null : value
                    if(type === "numeric" && value) {
                      value = parseFloat(value)
                    }
                    lineObj[title] = value
                  })
                  parsed.push(lineObj)
                })
              }

            }

            // resolve(parsed)
            resolve({data: parsed, name})
          } else {
            console.error(xhr.statusText);
          }
        }
      };

      xhr.onloadend = function() {
        if(xhr.status == 404) {
          console.log("404")
        }

      }
      xhr.onerror = function (e) {

        console.error(xhr.statusText);
      };

    })
  }

  getAllFiles() {
    let filenames = window.CONFIG.requiredFiles

    let promises = []
    for (let name in filenames) {
      promises.push( this.getFile(filenames[name], name) )
    }


    return Promise
    .all(promises)
    .then(files => {
      files.forEach(({name, data}) => {
        this[name] = data
      })

    })
  }
}

export default new DataLoading()